import { useMutation } from "@tanstack/react-query";
import { writeUrlAsFile } from "@components/download";
import { toast } from "@provider/toast";

type DownloadParams = {
  url: string;
  fileName: string;
  withToken: boolean;
};

type DownloadStatus = "idle" | "downloading" | "opening";

export function useDownloadFile() {
  const mutation = useMutation({
    mutationFn: async (params: DownloadParams) => {
      const result = await writeUrlAsFile(params);
      if (!result) {
        throw new Error("Download mislukt");
      }
    },
    onError: () => {
      toast.show("Er is iets fout gegaan.");
    },
  });

  const status: DownloadStatus = mutation.isPending ? "downloading" : "idle";

  return {
    download: mutation.mutate,
    isLoading: mutation.isPending,
    status,
    statusLabel: status === "downloading" ? "Downloaden..." : undefined,
  };
}
